module.exports = __webpack_public_path__ + "static/media/report_company.13eb8d84.svg";